import { Stack, Typography } from '@mui/material';
import config from 'config/default';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { ProfileValues } from 'types/profile.types';
import PaiButton from '../../ui/base-components/pai-button';
import PaiStepSlider from '../../ui/base-components/pai-step-slider';

interface Props {
  profile: ProfileValues;

  handleSliderChange(value: number, variable: string): void;

  handleOpenPersonaNameDialog(): void;
}

const CreateManualProfile: React.FC<Props> = ({ profile, handleSliderChange, handleOpenPersonaNameDialog }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const getVariable = (variable: string) => {
    switch (variable) {
      case 'jointPosPower':
        return profile.jointPosPower;
      case 'jointPosAchieve':
        return profile.jointPosAchieve;
      case 'jointPosAffil':
        return profile.jointPosAffil;
      case 'authenticity':
        return profile.authenticity;
      case 'regFocus':
        return profile.regFocus;
      default:
        return profile.regFocus;
    }
  };

  return (
    <div className={classes.container}>
      <Stack direction={'column'} spacing={4}>
        {_.map(_.get(config, 'augmentedWriting.customer.scores'), (value, key) => {
          if (key !== 'diversity') {
            const lowest: string | undefined = _.head(_.get(config, `augmentedWriting.customer.profileMapping.${key}`));
            const highest: string | undefined = _.last(_.get(config, `augmentedWriting.customer.profileMapping.${key}`));
            const name = _.get(config, `augmentedWriting.customer.scores.${key}.chart.label`);
            return (
              <div key={key}>
                <div className={classes.titleContainer}>
                  <Typography className={classes.title}>{name}</Typography>
                  <Typography className={classes.title}>{(getVariable(key) + 1).toFixed(0)}</Typography>
                </div>
                <PaiStepSlider
                  id={key}
                  max={5}
                  value={getVariable(key)}
                  handleChange={handleSliderChange}
                  leftText={lowest || t('vlow')}
                  rightText={highest || t('vhigh')}
                />
              </div>
            );
          }
          return;
        })}
      </Stack>
      <div className={classes.buttonContainer}>
        <PaiButton text={t('save')} action={handleOpenPersonaNameDialog} />
      </div>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  container: {
    width: '100%',
    border: `2px solid ${theme.palette.backgrounds.main}`,
    padding: '20px 16px',
    height: 'calc(100% - 39px - 16px - 20px)',
  },
  title: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    marginBottom: '8px',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '16px',
  },
}));

export default CreateManualProfile;
